import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClassroomMeetingFormWrapperModule } from '@app/classrooms/_components';
import { MeetingsCardModule } from '@app/core/components/meeting-card/meetings-card.module';
import { PaginationModule } from '@app/core/components/pagination/pagination.module';
import { FilterContentComponent } from '@app/library/panes/filter-content/filter-content.component';
import { MeetingFormWrapperModule } from '@core/components/meeting-form-wrapper/meeting-form-wrapper.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { PipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { ClassroomMeetingsPageComponent } from './classroom-meetings-page.component';

@NgModule({
  declarations: [ClassroomMeetingsPageComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MeetingsCardModule,
    PaginationModule,
    PipesModule,
    FilterContentComponent,
    NoContentStubComponent,
    ModalModule,
    MeetingFormWrapperModule,
    MobileModalModule,
    ClassroomMeetingFormWrapperModule,
  ],
  exports: [ClassroomMeetingsPageComponent],
})
export class ClassroomMeetingsPageModule {}
